import React from "react";
import { Link, useRouteError } from "react-router-dom";
import PropTypes from "prop-types";

import './Error.scss';

import { bankco } from "../../../assets/svg";

import ImageWithFallback from "../ImagewithFallback";

export default function Error() {
  const err = useRouteError();

  return (
    <div className="errorContainer">
      <div className="errorContent">
        <ImageWithFallback src={bankco} alt="Loading..." />
        <div>Something went wrong!!!!!</div>
        <Link to="/" className="homeLink">Go to Home</Link>
        <div className="errorMessage">{err?.data}</div>
      </div>
    </div>
  );
}

Error.propTypes = {
  err: PropTypes.shape({
    data: PropTypes.string,
  }),
};